export const environment = {
  build: 'pre',
  apiUrl: 'https://overinhibited-adoptional-burt.ngrok-free.dev/api/v1',
  appStoreUrl: 'https://apps.apple.com/us/app/pyramid-coaching/id6761129369',
  googlePlayUrl:
    'https://play.google.com/store/apps/details?id=com.pyramid.coaching&pcampaignid=web_share',
};
